// Which hosts may load the trackers and fire Lead conversions (#1303).
//
// Vercel preview deploys are built with the production pixel/GA4 env, so an
// env check alone let every `*.vercel.app` preview send PageView (and Lead)
// into the live Meta dataset, and Meta flagged the preview domains. The
// trackers now run only on the production domain and its subdomains, plus
// loopback so local dev and the e2e suite (which stubs fbq/gtag on localhost)
// still exercise the Lead pipeline. Everything else, the production
// deployment's own vercel.app URL included, is off.
//
// Mirrored in apps/marketing/src/lib/tracking-host.ts; keep the two in step.

const PRODUCTION_DOMAIN = "tristanoscatering.ca";
const LOOPBACK_HOSTS = new Set(["localhost", "127.0.0.1"]);

/**
 * True when `hostname` (default: the current page's) is a production host or
 * loopback. False with no window (SSR) and on any error, so tracking fails
 * closed. Never throws.
 */
export function trackingHostAllowed(hostname?: string): boolean {
  try {
    const raw = hostname ?? (typeof window === "undefined" ? "" : window.location.hostname);
    const host = raw.toLowerCase();
    return host === PRODUCTION_DOMAIN || host.endsWith(`.${PRODUCTION_DOMAIN}`) || LOOPBACK_HOSTS.has(host);
  } catch {
    // An unreadable location (a sandboxed embed) counts as "not production".
    return false;
  }
}
